import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  public size_;
  
  @Input() center = false;
  @Input() size = '50';

  constructor() { }

  ngOnInit(): void {
      this.size_ = this.size + "px";
  }
  

}
